import type { Shipment } from "api";
import cn from "classnames";
import { carrierLogoFallback } from "components/Shipments/CarrierLogo";
import type { LoadStatus } from "hooks/useProfile";
import type { GotoTarget } from "./dashboard.model";
import { arrivals, ARRIVALS_WINDOW_DAYS } from "./dashboard.model";
import { DashboardCard } from "./DashboardCard";

type ArrivalsCardProps = {
  shipments: Shipment[];
  status: LoadStatus;
  onGoto: (target: GotoTarget) => void;
};

/** What lands next, soonest first — overdue cards sort to the top on their own. */
export const ArrivalsCard = ({ shipments, status, onGoto }: ArrivalsCardProps) => {
  const rows = arrivals(shipments);

  return (
    <DashboardCard
      wide
      title={`Arrivals · next ${ARRIVALS_WINDOW_DAYS} days`}
      sub="Ordered by ETA, delays first"
      action={{ label: "All shipments", onClick: () => onGoto({ pane: "shipments", sub: "shipments" }) }}
      status={status}
      isEmpty={rows.length === 0}
      empty={`Nothing due in the next ${ARRIVALS_WINDOW_DAYS} days.`}
      failure="Could not load your shipments. Please refresh the page."
    >
      <div className="dsh__arr">
        {rows.map((row) => (
          <div className="dsh__arr-r" key={row.id}>
            <img
              className="dsh__cube"
              src={row.cube}
              alt=""
              width={34}
              height={34}
              loading="lazy"
              onError={carrierLogoFallback}
            />

            <div className="dsh__arr-n">
              <b>{row.reference}</b>
              <em>{row.route}</em>
            </div>

            {/* Without a departure date there is nothing to measure progress
                against, so the track is left out rather than guessed at. */}
            {row.progress === null ? (
              <span />
            ) : (
              <div className="dsh__track">
                <i style={{ left: `${row.progress}%` }} />
              </div>
            )}

            <span className={cn("pc-tag", row.tag.modifier)}>{row.tag.label}</span>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};
